import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    manufacturersRefreshDevicesConfigRequest,
    clearRedux,
} from 'Redux/actions';

const RefreshDevicesConfig = (props) => {
    const { tableRef } = props;
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const { loading, openModal, result } = useSelector(state => state.refreshDevicesConfigRedux);

    const closeModal = () => {
        dispatch(clearRedux("MANUFACTURER_REFRESH_DEVICES_CONFIG"));
    }

    const refresh = () => {
        dispatch(manufacturersRefreshDevicesConfigRequest());
    }

    useEffect(() => {
        if (result?.refresh) {
            tableRef && tableRef?.current?.getData();
            NotificationManager.success(
                messages['refresh_devices_config_success_message'],
                messages['refresh_devices_config_title'],
                3000
            );
            closeModal();
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['refresh_devices_config_title']}
            loading={loading}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <label style={{ marginBottom: 5 }}>
                        {messages['refresh_devices_config_question']}
                    </label>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => refresh()}
                >
                    {messages['refresh_devices_config_refresh']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default RefreshDevicesConfig;